import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import { Spin } from 'antd'

const ReactQueryDevtools = import.meta.env.DEV
  ? React.lazy(() =>
      import('@tanstack/react-query-devtools').then((m) => ({
        default: m.ReactQueryDevtools,
      })),
    )
  : (): null => null

import { useProactiveRefresh } from '@/features/auth/hooks/useProactiveRefresh'
import { triggerProactiveRefresh } from '@/lib/urqlClient'

const SessionKeeper: React.FC = () => {
  useProactiveRefresh(triggerProactiveRefresh)
  return null
}

/**
 * Top-level layout. Holds dayjs locale syncing, the session-keeper,
 * the suspense boundary that wraps the route outlet, and the React
 * Query devtools in dev mode.
 */
export const AppLayout: React.FC = () => {
  const { i18n } = useTranslation()
  dayjs.locale(i18n.language)

  return (
    <>
      <SessionKeeper />
      <Suspense
        fallback={
          <div
            style={{
              display: 'flex',
              minHeight: '100vh',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Spin size="large" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
      <Suspense fallback={null}>
        <ReactQueryDevtools initialIsOpen={false} />
      </Suspense>
    </>
  )
}
